export interface SelectPrestationTypeOption {
  value: any;
  label: string;
  selected: boolean;
  startHours: string;
  endHours: string;
  color: {
    text: string,
    background: string
  }
}
